import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import mixpanel from './mixpanel';

const PageViewTracker: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        mixpanel.track('Page Viewed', {
            page: location.pathname,
        });
    }, [location]);

    return null;
};

export default PageViewTracker;
